module.exports = __webpack_public_path__ + "img/img_product_default.ff508731.png";